/**
 * Common API Configuration Constants
 * Centralized configuration for all API calls across the application
 */

/**
 * Retry Configuration for API Calls
 * Used by all API calls (auth, upload, datasets, contracts, etc.)
 */
export const RETRY_CONFIG = {
    enabled: process.env.REACT_APP_ENABLE_API_RETRY !== 'false', // Default: enabled (set to 'false' to disable)
    maxRetries: parseInt(process.env.REACT_APP_API_MAX_RETRIES || '3', 10),
    baseDelay: parseInt(process.env.REACT_APP_API_RETRY_DELAY || '2000', 10)
};

/**
 * Helper to get retry configuration details
 */
export const getRetryConfig = () => ({
    enabled: RETRY_CONFIG.enabled,
    maxRetries: RETRY_CONFIG.maxRetries,
    baseDelay: RETRY_CONFIG.baseDelay,
    maxDelay: RETRY_CONFIG.baseDelay * Math.pow(2, RETRY_CONFIG.maxRetries - 1),
    totalAttempts: RETRY_CONFIG.maxRetries + 1
});

export const DEFAULT_API_HEADERS = {
    accept: 'application/json',
    'Request-Source': 'ui',
};